<template>
  <div style="display: contents">
    <button
      type="button"
      class="button white"
      :class="buttonClass"
      @click.prevent="is_showing_date_modal = true"
      v-text="presentDate(value)"
    />

    <portal to="app-end">
      <!-- Date Modal -->
      <date-modal
        v-show="is_showing_date_modal"
        :thedate="value"
        :thetype="thetype"
        :hidenav="hidenav"
        @choose-date="$emit('input', $event)"
        @choose-type="$emit('choose-type', $event)"
        @hide-modal="is_showing_date_modal = false"
      />
    </portal>
  </div>
</template>

<script>
export default {
  name: "DatePicker",
  props: ['value', 'hidenav', 'thetype', 'buttonClass'],
  data: () => ({
    is_showing_date_modal: false,
  }),
  methods: {
    presentDate(date) {
      return new Date(date).toLocaleDateString('en-us', {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        timeZone: 'UTC',
      });
    },
  },
}
</script>

<style scoped>

</style>